<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs"/>
    <b-row>
      <b-col md="6">
        <b-card title="Reset My Password">
          <b-form v-on:submit.prevent.stop="submit" v-if="status === 'ready'">
            <p>Please enter your new password below.
            <b-form-group id="new_password_label" label="New Password" label-for="new_password">
              <b-input id="new_password" type="password" v-model="newPassword" required></b-input>
            </b-form-group>
            <b-alert variant="warning" :show="showPasswordWarning">Password is not secure. {{passwordWarning}}</b-alert>
            <b-form-group id="confirm_new_password_label" label="Confirm New Password" label-for="confirm_new_password">
              <b-input id="confirm_new_password" type="password" v-model="confirmNewPassword" required></b-input>
            </b-form-group>
            <b-alert variant="danger" :show="errorMessage != null">{{errorMessage}}</b-alert>
            <div class="text-right">
              <b-button to="/">Cancel</b-button>
              <b-button type="submit" variant="primary">Save</b-button>
            </div>
          </b-form>
          <div v-if="status === 'expired'">
            <b-alert show">Sorry, this link has expired.</b-alert>
            <p>
              To request a new password reset link, please
              <router-link to="/account/password/forgot">click here.</router-link>
            </p>
          </div>
          <div v-if="status === 'complete'">
            <p>Thank you, your password has been reset. You can now log in.</p>
            <p class="text-right">
              <b-button to="/" primary>Log In</b-button>
            </p>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import API from '@/lib/api'
import zxcvbn from 'zxcvbn'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      breadcrumbs: [{text: 'Vos Voco', to: '/'}, {text: 'Forgot Passsword', to: '/account/password', reset: true}],
      oldPassword: null,
      newPassword: null,
      confirmNewPassword: null,
      errorMessage: null,
      showPasswordWarning: false,
      passwordWarning: null,
      status: 'loading'
    }
  },
  watch: {
    'newPassword': function () {
      const result = zxcvbn(this.newPassword)
      this.showPasswordWarning = (result.score < 3)
      if (result.feedback != null && result.feedback.warning != null && result.feedback.warning !== '') {
        this.passwordWarning = result.feedback.warning
      } else {
        this.passwordWarning = result.feedback.suggestions.join('. ')
      }
    }
  },
  created: function () {
    API.get('account/password/' + this.$route.params.token)
      .then((response) => {
        if (response.data != null) {
          this.status = 'ready'
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          this.status = 'expired'
        }
      })
  },
  methods: {
    submit: function () {
      API.post('account/password/' + this.$route.params.token, {
        password: this.newPassword
      })
        .then((response) => {
          this.status = 'complete'
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.error = error.response.data.message
            this.status = 'ready'
          } else if (error.response && error.response.status === 404) {
            this.status = 'expired'
          }
          console.log(error)
        })
      console.log('submit')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword.vue